import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";

const EditNormalOrderModal = ({
  OrderSingleData,
  handleCloseNormalOrderEdit,
  setResults,
}) => {


  const [platformTypeData, setPlatformTypeData] = useState([]);
  const [productData, setProductData] = useState([]);

  const [platformType, setPlatformType] = useState(
    OrderSingleData?.platformTypeId?._id ||
    OrderSingleData?.platformTypeId ||
    ""
  );

  // console.log(OrderSingleData)

  const [SelectedProduct, setSelectedProduct] = useState(null);
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [orderAmount, setOrderAmount] = useState("");
  const [profit, setProfit] = useState("");
  const [expectedIncome, setExpectedIncome] = useState("");

  const [errorMessage, setErrorMessage] = useState({});
  const refSubmitDis = useRef(null);

  // Load existing order data
  useEffect(() => {
    const orderProduct = OrderSingleData?.products?.[0];

    setPlatformType(
      OrderSingleData?.platformTypeId?._id ||
      OrderSingleData?.platformTypeId ||
      ""
    );

    setProfit(String(OrderSingleData?.profit ?? ""));
    setQuantity(String(orderProduct?.quantity ?? ""));

    setPrice(
      String(
        orderProduct?.price ??
        orderProduct?.productId?.price ??
        ""
      )
    );

    setOrderAmount(String(OrderSingleData?.subtotal ?? ""));

    setExpectedIncome(
      String(OrderSingleData?.totalWithProfit ?? "")
    );
  }, [OrderSingleData]);

  // Fetch Platform Types
  useEffect(() => {
    const fetchPlatformTypes = async () => {
      try {
        const response = await axios.get(
          "https://api.velormall.com/api/admin/platform-type/all/view"
        );

        setPlatformTypeData(response?.data?.data || []);
      } catch (error) {
        toast.error("Failed to load platform types");
      }
    };

    fetchPlatformTypes();
  }, []);

  // Fetch Products and select existing product
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get(
          "https://api.velormall.com/api/admin/product/all/view"
        );

        const products = response?.data?.data || [];
        setProductData(products);

        const existingProductId =
          OrderSingleData?.products?.[0]?.productId?._id ||
          OrderSingleData?.products?.[0]?.productId;

        const selected = products.find(
          (item) => item._id === existingProductId
        );

        setSelectedProduct(selected || null);

        if (selected) {
          setPrice(
            String(
              OrderSingleData?.products?.[0]?.price ??
              selected.price ??
              ""
            )
          );
        }
      } catch (error) {
        toast.error("Failed to load products");
      }
    };

    fetchProducts();
  }, [OrderSingleData]);

  // Handle Product Selection
  const handleProductChange = (e) => {
    const selected = productData.find(
      (item) => item._id === e.target.value
    );

    setSelectedProduct(selected || null);
    setPrice(selected ? String(selected.price ?? "") : "");
    setQuantity(selected ? "1" : "");
    setProfit("");
    setOrderAmount("");
    setExpectedIncome("");
    setErrorMessage({});
  };

  // Calculate Amount and Expected Income
  useEffect(() => {
    if (
      !SelectedProduct ||
      price === "" ||
      quantity === "" ||
      !Number.isFinite(Number(price)) ||
      !Number.isFinite(Number(quantity)) ||
      Number(price) < 0 ||
      Number(quantity) < 1
    ) {
      setOrderAmount("");
      setExpectedIncome("");
      return;
    }

    const amount = Number(price) * Number(quantity);

    setOrderAmount(String(amount));

    if (
      profit === "" ||
      !Number.isFinite(Number(profit)) ||
      Number(profit) < 0
    ) {
      setExpectedIncome("");
      return;
    }

    const profitAmount = (amount * Number(profit)) / 100;

    setExpectedIncome(String(amount + profitAmount));
  }, [SelectedProduct, price, quantity, profit]);

  // Submit Update
  const handleSubmitData = async (event) => {
    event.preventDefault();
    setErrorMessage({});

    if (refSubmitDis.current) {
      refSubmitDis.current.disabled = true;
    }

    try {
      const orderId = OrderSingleData?._id;
      if (!orderId) {
        toast.error("Order ID not found");
        return;
      }

      const payload = {
        type: OrderSingleData?.type || "Normal",
        orderSetId:
          OrderSingleData?.orderSetId?._id ||
          OrderSingleData?.orderSetId,
        platformTypeId: platformType,
        profit: Number(profit),
        products: [
          {
            productId: SelectedProduct?._id || "",
            price: Number(price),
            quantity: Number(quantity),
            totalAmount:
              Number(price) * Number(quantity),
          },
        ],

      };

      const response = await axios.put(
        `https://api.velormall.com/api/admin/order/update/${orderId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        setResults(response.data);
        toast.success(response.data.message);
        handleCloseNormalOrderEdit();
      } else {
        setErrorMessage(response?.data?.errors || {});
        if (response?.data?.message) {
          toast.error(response?.data?.message);
        }
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.errors || {});
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    } finally {
      if (refSubmitDis.current) {
        refSubmitDis.current.disabled = false;
      }
    }
  };

  return (
    <>
      <Modal.Body>
        <form onSubmit={handleSubmitData}>
          <div className="modal-body">
            {/* Select Platform */}
            <div className="form-group">
              <label htmlFor="platformType" className="required">
                Select Platform
              </label>

              <select
                className="form-control"
                name="platformTypeId"
                id="platformType"
                value={platformType}
                onChange={(e) => setPlatformType(e.target.value)}
                required
              >
                <option value="">Select Platform</option>

                {platformTypeData.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </select>

              {errorMessage?.platformTypeId && (
                <span className="text-danger pt-2">
                  {errorMessage.platformTypeId.msg}
                </span>
              )}
            </div>

            {/* Select Product */}
            <div className="form-group">
              <label htmlFor="productId" className="required">
                Manage Product
              </label>

              <select
                className="form-control"
                name="productId"
                id="productId"
                value={SelectedProduct?._id || ""}
                onChange={handleProductChange}
                required
              >
                <option value="">Select Product</option>

                {productData.map((item) => (
                  <option key={item._id} value={item._id}>
                    {item.name}
                  </option>
                ))}
              </select>

              {errorMessage?.["products[0].productId"]?.msg && (
                <span className="text-danger pt-2">
                  {errorMessage["products[0].productId"].msg}
                </span>
              )}
            </div>

            {/* Profit */}
            <div className="form-group">
              <label htmlFor="profit" className="required">
                Add Profit %
              </label>

              <input
                type="number"
                className="form-control"
                name="profit"
                id="profit"
                value={profit}
                onChange={(e) => setProfit(e.target.value)}
                min="0"
                step="any"
                required
              />

              {errorMessage?.profit && (
                <span className="text-danger pt-2">
                  {errorMessage.profit.msg}
                </span>
              )}
            </div>

            {/* Price */}
            <div className="form-group">
              <label htmlFor="price" className="required">
                Price
              </label>

              <input
                type="number"
                className="form-control"
                name="price"
                id="price"
                value={SelectedProduct ? price : ""}
                readOnly
              />

              {errorMessage?.price && (
                <span className="text-danger pt-2">
                  {errorMessage.price.msg}
                </span>
              )}
            </div>

            {/* Quantity */}
            <div className="form-group">
              <label htmlFor="quantity" className="required">
                Quantity
              </label>

              <input
                type="number"
                className="form-control"
                name="quantity"
                id="quantity"
                value={SelectedProduct ? quantity : ""}
                onChange={(e) => setQuantity(e.target.value)}
                min="1"
                step="1"
                required
              />

              {errorMessage?.["products[0].quantity"]?.msg && (
                <span className="text-danger pt-2">
                  {errorMessage["products[0].quantity"].msg}
                </span>
              )}
            </div>

            {/* Order Amount */}
            <div className="form-group">
              <label htmlFor="subtotal" className="required">
                Order Amount
              </label>

              <input
                type="number"
                className="form-control"
                name="subtotal"
                id="subtotal"
                value={SelectedProduct ? orderAmount : ""}
                readOnly
              />

              {errorMessage?.subtotal && (
                <span className="text-danger pt-2">
                  {errorMessage.subtotal.msg}
                </span>
              )}
            </div>

            {/* Expected Income */}
            <div className="form-group">
              <label htmlFor="expectedIncome" className="required">
                Expected Income
              </label>

              <input
                type="number"
                className="form-control"
                name="totalWithProfit"
                id="expectedIncome"
                value={SelectedProduct ? expectedIncome : ""}
                readOnly
              />

              {errorMessage?.totalWithProfit && (
                <span className="text-danger pt-2">
                  {errorMessage.totalWithProfit.msg}
                </span>
              )}
            </div>

            <button
              type="submit"
              ref={refSubmitDis}
              className="btn btn-primary w-100 h-45"
            >
              Update Order
            </button>
          </div>
        </form>
      </Modal.Body>
    </>
  );
};

export default EditNormalOrderModal;